module.exports = __webpack_public_path__ + "static/media/hero-banner.8cfec128.jpg";